import axios from "axios";
import React, { useEffect, useState } from "react";

export default function Compgoal({ id_user }) {
  const urlapi = process.env.REACT_APP_BASE_URL;
  const [goal, setGoal] = useState(0);

  const getdata = async () => {
    try {
      const response = await axios.get(
        urlapi + "Jmlgoalmemberkarir?id_user=" + id_user
      );
      setGoal(response.data);
      console.log(response.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    getdata();
  }, []);
  return (
    <div>
      <div className="container my-5">
        <center>
          <img
            src="/img/goal2.png"
            className="img-fluid"
            alt="Responsive image"
            style={{ height: "200px" }}
          ></img>
          <h5 className="mt-3 fw-bold">Goal yang di proleh sebanyak</h5>
          <h1 className="fw-bold text-success">{goal.jml} GOAL</h1>
        </center>
      </div>
    </div>
  );
}
